import { render, staticRenderFns } from "./VisualEditor.vue?vue&type=template&id=5610b84e&scoped=true"
import script from "./VisualEditor.vue?vue&type=script&lang=js"
export * from "./VisualEditor.vue?vue&type=script&lang=js"
import style0 from "./VisualEditor.vue?vue&type=style&index=0&id=5610b84e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5610b84e",
  null
  
)

export default component.exports